import { render } from "./ChipsComponent.vue?vue&type=template&id=065aafc2"
import script from "./ChipsComponent.vue?vue&type=script&lang=js"
export * from "./ChipsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__